import { useTranslation } from "react-i18next";
import AppLayout from "./AppLayout";

const AdminLayout = () => {
    const {t} = useTranslation();

    const ADMIN_MENU = [
        {
            menutitle: `${t('sideBar.adminPanel')}`,
            Items: [
                {
                    path: `${process.env.PUBLIC_URL}/admin/user/management`,
                    icon: 'ti-id-badge',
                    type: 'link',
                    active: false,
                    selected: false,
                    title: `${t('sideBar.userManagment')}`,
                    highlighted: true,
                },
                {
                    path: `${process.env.PUBLIC_URL}/admin/role/management`,
                    icon: 'ti-layers-alt',
                    type: 'link',
                    active: false,
                    selected: false,
                    title: `${t('sideBar.roleManagment')}`,
                    highlighted: false,
                    disabled: true
                },
            ]
        },
        {
            menutitle: `${t('sideBar.userPanel')}`,
            Items: [
                {
                    path: `${process.env.PUBLIC_URL}/`,
                    icon: 'ti-bar-chart',
                    type: 'link',
                    active: false,
                    selected: false,
                    title: `${t('sideBar.dashboardLow')}`,
                    highlighted: true,
                },
            ]
        },
        
    ];

    
    return <AppLayout SideMenuLinks={ADMIN_MENU}/>
    }
export default AdminLayout